import { TextTemplateKey } from "../../components/types";
import { LocalizedTextStateContext } from "../../contexts/localized-text-context-provider";
import { LocalizedTextState } from "../../contexts/types";
import { useContextSafely } from "../../utils/react-utils";

/**
 * A hook that return the active textTemplatesByLanguage for the `LocalizedTextProvider`.
 *
 * @param suppressErrorMessage Suppress console error message when the hook is used without `LocalizedTextProvider`.
 */
export function useTextTemplatesByLanguage<T extends TextTemplateKey = TextTemplateKey>(
  suppressErrorMessage?: boolean
) {
  return useContextSafely<LocalizedTextState<T>>(
    LocalizedTextStateContext,
    suppressErrorMessage,
    useTextTemplatesByLanguage.name
  )?.textTemplatesByLanguage;
}
